import React from 'react';

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/919528480615?text=Hello%2C%20I%20am%20interested%20in%20your%20products.%20Please%20share%20details."
      target="_blank"
      rel="noreferrer"
      className="wa-float"
      title="Chat on WhatsApp"
      aria-label="Chat on WhatsApp"
    >
      💬
    </a>
  );
};

export default WhatsAppFloat;
